export default __webpack_public_path__ + "static/media/eth.6f2deb63.svg";